import { render } from "./Informacoes.vue?vue&type=template&id=b3392d7c&scoped=true"
import script from "./Informacoes.vue?vue&type=script&lang=js"
export * from "./Informacoes.vue?vue&type=script&lang=js"

import "./Informacoes.vue?vue&type=style&index=0&id=b3392d7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3392d7c"]])

export default __exports__